<app-invoice-display
        [invoices] = "invoices$"
></app-invoice-display>
